<template>
    <div class="container">
        <div class="title-h1">
        <h1 class="title" v-show="windowWidth >=600 ">65.000 desarrolladores en 12 países</h1>
        <h1 class="title-2" v-show="windowWidth <600 ">65.000 desarrolladores en 12 países</h1>
    </div>
        <div class="cards">
            <div class="card">
                <div class="detail">
                    <img src="/external/jose_rafael.png" class="circle" >
                    <h4 class="text-title">Jose R. Gutierrez</h4>
                    <p class="text-range">Desarrollador Software</p>
                    <p class="text-detail">+10 Años de experiencia</p>
                    <p class="text-detail">Software</p>
                    <a href="https://campus-ademass.com/salon-de-la-fama" class="view-more" target="_blank">Ver más</a>
                </div>
            </div>
            <div class="card">
                <div class="detail">
                    <img src="/external/victor.png" class="circle" >
                    <h4 class="text-title">Victor Rodriguez</h4>
                    <p class="text-range">Desarrollador Web</p>
                    <p class="text-detail">+1 Año de experiencia</p>
                    <p class="text-detail">FrontEnd</p>
                    <a href="https://campus-ademass.com/salon-de-la-fama" class="view-more-green" target="_blank">Ver más</a>
                </div>
            </div>
    
            <div class="card">
                <div class="detail">
                    <img src="/external/marco.png" class="circle" >
                    <h4 class="text-title">Marco Mamani</h4>
                    <p class="text-range">Desarrollador Backend</p>
                    <p class="text-detail">+2 Años de experiencia</p>
                    <p class="text-detail">BackEnd</p>
                    <a href="https://campus-ademass.com/salon-de-la-fama" class="view-more" target="_blank">Ver más</a>
                </div>
            </div>
    
            <div class="card">
                <div class="detail">
                    <img src="/external/neus.png" class="circle" >
                    <h4 class="text-title">Neus Román Piqué</h4>
                    <p class="text-range">Desarrolladora App</p>
                    <p class="text-detail">+2Años de experiencia</p>
                    <p class="text-detail">App</p>
                    <a href="https://campus-ademass.com/salon-de-la-fama" class="view-more-green" target="_blank">Ver más</a>
                    
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script setup>
    import useWindowWidth from '@/composables/useWindowWidth';

    const { windowWidth } = useWindowWidth();
    </script>
    
    <style scoped>
    @media screen and (max-width: 450px){
       .title-h1{
        display: flex;
        height: auto;
        justify-content: center;
        align-items: center;
        margin: 10px; 
       }
    }
    p{
        margin-bottom: 5px;
    }
      .container{
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
            margin-bottom: 100px;
        }
    .title {
          color: rgba(39, 52, 68, 1);
          font-size: 60px;
          font-style: Black;
          text-align: center;
          font-family: Darker Grotesque;
          font-weight: 900;
        }
        .title-2 {
          color: rgba(39, 52, 68, 1);
          font-size: 50px;
          font-style: Black;
          text-align: center;
          font-family: Darker Grotesque;
          font-weight: 900;
        }
        .text-range {
            margin-top: 0;
            color: rgba(39, 52, 68, 1);
            max-width: 400px;
            font-size: 24px;
            font-style: Medium;
            font-family: Darker Grotesque;
            font-weight: 500;
            line-height: 94.9999988079071%;  
        }
        .text-title {
      color: rgba(35, 35, 35, 1);
      font-size: 28px;
      font-style: Bold;
      text-align: center;
      font-family: Darker Grotesque;
      font-weight: 700;
      line-height: 94.9999988079071%;
    }
    .text-detail{
      color: rgba(35, 35, 35, 1);
      font-size: 20px;
      font-style: Medium;
      text-align: center;
      font-family: Darker Grotesque;
      font-weight: 500;
      line-height: 94.9999988079071%;
    }
    .cards{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    .card{
        background-color: #d9d9d9;
        padding: 20px;
        margin: 10px;
        width: 260px;
    }
    .detail{
        display: flex;
        flex-direction: column;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        justify-content: center;
        align-items: center;
        box-shadow: 8px 8px 8px  #ccc;
        line-height: 94.9999988079071%;
    }
    .circle{
        background-color: #d9d9d9;
        height: 100px;
        width: 100px;
        border-radius: 50%;
    }
    .view-more-green{
        margin-top: 15px;
        text-decoration: none;
        background-color:rgba(196, 207, 44, 1) ;
        border: 2px solid rgba(196, 207, 44, 1);
        padding: 13px;
        color: white;
        font-weight: 600;
        font-size: 24px;
        font-style: SemiBold;
        font-family: Darker Grotesque;
    }
    .view-more-green:hover {
  background-color: white;
  color: rgba(196, 207, 44, 1);
  border: 2px solid rgba(196, 207, 44, 1);
}
.view-more:hover {
  background-color: white;
  color: rgba(46, 163, 242, 1) ;
  border: 2px solid rgba(46, 163, 242, 1) ;
}
    .view-more{
        margin-top: 15px;
        text-decoration: none;
        background-color:rgba(46, 163, 242, 1) ;
        border: 2px solid rgba(46, 163, 242, 1) ;
        padding: 13px;
        color: white;
        font-size: 24px;
        font-weight: 600;
        font-style: SemiBold;
        font-family: Darker Grotesque;
    }
    </style>